/* eslint-disable no-param-reassign */
import find from 'lodash/find';
import filter from 'lodash/filter';
import get from 'lodash/get';
import map from 'lodash/map';
import each from 'lodash/each';
import some from 'lodash/some';
import keys from 'lodash/keys';
import compact from 'lodash/compact';
import extend from 'lodash/extend';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import isUndefined from 'lodash/isUndefined';
import { deepClone, eachHierarchy, htmlDecode, getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import Search from '@Services/Search';
import AppStorage from '@Services/AppStorage';
import { v4 as uuid } from 'uuid';
import * as QueryContainerHelper from '@Pages/QueryBuilder/QueryContainer/QueryContainerHelper';
import isEmpty from 'lodash/isEmpty';
import UserForms from '@Services/UserForms';
import * as qbHelpersService from '@Services/QBHelpers';
import CatalystHelper from '@Services/CatalystHelper';
import QueryParser from '@Services/QueryParser';
import * as AdvancedQuery from '@Services/AdvancedQuery';
import StructureContainers from '@Services/StructureContainers';
import isArray from 'lodash/isArray';
import AdvancedHistory from '@Services/AdvancedHistory';
import History from '@Services/History';
import * as QBTreeHelper from '@Services/QBTreeHelper';
import pick from 'lodash/pick';
import * as queryletConstants from './QueryletConstants';
import {
  forms,
  hiddenList,
  properties,
  searchSectionOpenedTab as searchSectionOpenedTabSelector,
  searchSectionOpenedPanels as searchSectionOpenedPanelsSelector,
} from './QuerySelector';
import { findParentNode } from './Shared/queryTreeUtils';

export const renameGroupTitle = (groupedItem) => ({
  type: queryletConstants.RENAME_GROUP_TITLE,
  payload: { groupedItem },
});

function prepareItem(item, favList = [], _hiddenList = []) {
  if (item.type === 'formula' || item.type === 'history') {
    item.isOnlyOnce = true;
  }

  if (item.displayName && /(<\w+>)|(&\w+;)/.test(item.displayName)) {
    // work with dom requires a lot of resources
    item.displayName = htmlDecode(item.displayName);
  }

  if (_hiddenList.includes(item.id) || _hiddenList.includes(item.syntaxName)) {
    item.hidden = true;
  }

  const fav = find(QueryContainerHelper.DEFAULT_FAVS, { id: item.id });
  if (item.type !== 'field' && fav) {
    item.shortName = fav.shortName;
    item.iconId = fav.iconId;
    item.fullName = fav.fullName;
    item.automationId = fav.automationId;
    favList[fav.order] = item;
    item.label = fav.label;
  }
}

function updateDataType(node) {
  const newV = node;
  const operatorsList = ['AND', 'OR', 'NOT', 'PROXIMITY'];
  if (!newV || isEmpty(newV) || newV.type === 'form') {
    return;
  }

  if (newV.dataType === 'string' && newV.childrenCount > 0) {
    newV.dataType = 'complex';
  }

  if (newV.isCompact) {
    newV.dataType = 'compact';
  }

  if (newV.id === 'CBI.BICIT') {
    newV.dataType = 'word';
  } else {
    newV.dataType = newV.dataType || newV.type;
  }

  node.operator = node.operator || node.defaultOperation || operatorsList[0];
  node.value = 'value' in node ? node.value : node.defaultValue;
}

const setHidden = (_hiddenList, item, isHidden) => {
  item.hidden = isHidden;

  if (isHidden) {
    _hiddenList.push(item.id || item.syntaxName);
  } else {
    const index = findIndex(_hiddenList, item.id || item.syntaxName);
    _hiddenList.splice(index, 1);
  }

  AppStorage.instance.set('qbHiddenList', hiddenList);
};

function isMergedfromSideNavFn(item, sectionsTab, formsData, propertiesData) {
  let node = cloneDeep(item);
  if (node.type === 'form') {
    const form = QueryParser.parseQuery(node.content, propertiesData);
    node = new qbHelpersService.Shell(form, node.displayName, node.isImmutable);
  }
  if (node?.children?.length > 0) {
    node.children.forEach((child) => {
      child.uuid = uuid();
    });
    const firstInput = node.children.filter((input) => input.type === 'field')[0];
    if (firstInput) {
      firstInput.autofocus = true;
    }
  } else {
    node.autofocus = true;
  }

  qbHelpersService.setStructureUID(node);

  if (node.isOnlyOnce && !node.hidden) {
    setHidden(node, true);
  }

  if (sectionsTab) {
    CatalystHelper.setTreeNodeTrackingSearchType(node, sectionsTab.toLowerCase(), formsData);
  }

  if (item.preferredSearchContexts) {
    node.preferredSearchContexts = item.preferredSearchContexts;
  }
  return node;
}
export const addToBuilderAction = (item, sectionsTab, isMerged) => (dispatch, getState) => {
  if (!sectionsTab) {
    sectionsTab = searchSectionOpenedTabSelector(getState());
  }
  let node = cloneDeep(item);
  node = isMergedfromSideNavFn(node, sectionsTab, forms(getState()), properties(getState()));

  const nodeArr = [];
  updateDataType(node);
  node = { ...node, uuid: uuid() };
  nodeArr.push(node);

  const appStorageArr = [...nodeArr, ...(AppStorage.instance.get('qbNodesList') || [])];
  AppStorage.instance.set('qbNodesList', appStorageArr);
  if (isMerged) {
    const type = isMerged.isForm ? 'displayName' : 'id';
    const dragIndexValue = appStorageArr.findIndex((nodeVal) => nodeVal[type] === isMerged.dragId);
    // const index = appStorageArr.findIndex((nodeVal) => nodeVal.uuid === isMerged.dropId);
    // if (isMerged.issubItem) {
    const dragDetail = {
      index: dragIndexValue,
      id: appStorageArr[dragIndexValue][type],
      key: appStorageArr[dragIndexValue].uuid,
      obj: appStorageArr[dragIndexValue],
    };

    dispatch(
      // eslint-disable-next-line no-use-before-define
      mergeNodeItemAction(dragDetail, appStorageArr, {
        type: 'subItem',
        key: isMerged.dropId,
      })
    );
    // } else {
    //   const restNodes = isMerged.isForm
    //     ? []
    //     : appStorageArr.filter((nodes) => nodes.uuid !== isMerged.dropId && nodes.id !== isMerged.dragId);
    //   // eslint-disable-next-line no-use-before-define
    //   dispatch(mergeNodeAction(dragIndexValue, index, appStorageArr, restNodes, isMerged.isForm));
    // }
  } else {
    dispatch({
      type: queryletConstants.ADDTOBUILDER_NODES,
      payload: { nodesList: nodeArr },
    });
  }
};

export function editHistoryQuery(node) {
  return async (dispatch, getState) => {
    const nlqlFact = node.isSemanticSearchIncluded
      ? {
          id: 'Reaxys2071',
          logicOperator: 'OR',
          fields: [
            {
              value: `"${node.textQuery}"`,
              boundOperator: 'op_txt_is',
              id: 'CIT.NLQL',
              displayName: 'Natural Language Document Search',
              imported: true,
              isSemanticSearchIncluded: true,
            },
          ],
          fieldsLogicOperator: 'AND',
          exist: false,
          bio: false,
          isSemanticSearchIncluded: true,
        }
      : null;

    const appendNlqlFact = (item) => {
      if (!nlqlFact) return item;
      const facts = get(item, 'facts[0].facts', get(item, 'facts', []));
      return {
        ...item,
        facts: [
          {
            ...(item.facts?.[0] || { id: 'wrapper', groupName: 'Group', exist: false }),
            facts: [...facts, nlqlFact],
          },
        ],
      };
    };

    const addHistoryItemToNodes = (item) => {
      const parsedQuery = QueryParser.parseQuery(item, properties(getState()));
      const nodeArr = parsedQuery.map((_node) => {
        updateDataType(_node);
        return {
          ..._node,
          uuid: uuid(),
          ...(node.isSemanticSearchIncluded ? { isPreviewSemanticHistoryFlow: true } : {}),
        };
      });
      AppStorage.instance.set('qbNodesList', nodeArr);
      dispatch({
        type: queryletConstants.ADDTOBUILDER_NODES,
        payload: { nodesList: nodeArr },
      });
    };

    if (node.queryFactItem) {
      addHistoryItemToNodes(appendNlqlFact(node.queryFactItem));
    } else {
      try {
        const whereClauseImport = await AdvancedQuery.getQueryByWhereClause(node);
        if (whereClauseImport) {
          whereClauseImport.context = node.context;
          addHistoryItemToNodes(appendNlqlFact(whereClauseImport));
        }
      } catch (err) {
        Logger.error(err);
      }
    }
  };
}

export const initNodeList = () => (dispatch) => {
  Search.getSearchProperties()
    .then((data) => {
      let _favList = [];
      const _nodesList = AppStorage.instance.get('qbNodesList') || [];
      const _hiddenList = AppStorage.instance.get('qbHiddenList') || [];

      const factNodes = filter(data, (chr) => chr.type === 'facts');
      const facts = map(factNodes, 'tree');
      const _properties = eachHierarchy(facts, (fact) => prepareItem(fact, _favList, _hiddenList), undefined, { checkCircular: false });

      each(data, (chr) => {
        if (chr.type !== 'facts') {
          if (chr.type === 'formula' || chr.type === 'history') {
            chr.isOnlyOnce = true;
          }
          prepareItem(chr, _favList, _hiddenList);
          _properties.push(chr);
        }
      });
      _favList = compact(_favList);
      dispatch({
        type: queryletConstants.FETCH_NODES_LIST,
        payload: { nodesList: _nodesList, properties: _properties, favList: _favList, hiddenList: _hiddenList },
      });

      const clonedProperties = deepClone(_properties);
      QueryContainerHelper.initPropertiesList(clonedProperties);
      QueryContainerHelper.initSearchQueryletIndexedConstraints(clonedProperties);

      // handle default form coming from AE
      const defaultForm = AppStorage.instance.get('qbDefaultForm');
      if (defaultForm) {
        AppStorage.instance.remove('qbDefaultForm');
        addToBuilderAction(defaultForm);
      }
    })
    .catch(Logger.error);
};

export const updateOperatorAction = (item) => {
  const { operator, qualifier, node } = item;
  node.operator = operator;
  node.operatorQualifier = qualifier > 0 ? qualifier : null;
  return (dispatch) => {
    dispatch({
      type: queryletConstants.UPDATE_INDIVIDUAL_NODE,
      payload: { uuid: node.uuid, data: node },
    });
  };
};

export function insertByIndex(array, obj, index) {
  if (!isArray(array)) {
    return;
  }

  QBTreeHelper.insertByIndex(array, obj, index);
}

const findDragObj = (dragDetail, nodesListArr) =>
  nodesListArr.reduce((acc, child) => {
    if (isArray(child.items)) {
      // Recursively call for nested arrays
      child.items = findDragObj(dragDetail, child.items);
    }
    // Only add the item if it doesn't match the idToRemove
    if (child.uuid !== dragDetail.key) {
      acc.push(child);
    }
    return acc;
  }, []);

const updateDropObj = (nodeArr, destDetail, dragObj) => {
  nodeArr.forEach((node, index) => {
    // Check if this item has the target ID
    if (node.uuid === destDetail.key) {
      if (!isUndefined(node)) {
        if (isArray(node)) {
          insertByIndex(node, dragObj, index);
        } else {
          node.items = node.items || [];
          insertByIndex(node.items, dragObj, node);
          if (node.items.length) {
            qbHelpersService.convertToShell(node, 'items');
          }
        }
      }
      return;
    }
    // If the item has children, recurse into them
    if (node.items && node.items.length > 0) {
      updateDropObj(node.items, destDetail, dragObj);
    }
  });

  nodeArr = nodeArr
    .map((node) => {
      // Replace wrapper with its single item if it meets the criteria
      if (node.id === 'wrapper' && node.items.length === 1 && !node.trackingSearchType) {
        return { ...node.items[0] };
      }
      return node;
    })
    .filter((node) => !(node.id === 'wrapper' && node.items.length === 0));

  return { nodeArr };
};

export const mergeNodeItemAction = (dragDetail, nodesListArr, destDetail) => (dispatch) => {
  const result = findDragObj(dragDetail, nodesListArr);
  const { nodeArr } = updateDropObj(result, destDetail, dragDetail.obj);
  dispatch({
    type: queryletConstants.MERGE_DRAG_NODES,
    payload: { updatedObj: nodeArr },
  });
};

/** can be removed - need to test thoroughly once again */
export const mergeNodeAction = (dragIndex, destIndex, nodesListArr, restNodes, isForm) => (dispatch) => {
  let nodeListArray = [...nodesListArr];
  const dropObj = nodesListArr[destIndex];
  const dragObj = nodesListArr[dragIndex];
  let updatedObj;
  if (!isUndefined(dropObj)) {
    if (isArray(dropObj)) {
      insertByIndex(dropObj, dragObj, destIndex);
    } else {
      dropObj.items = dropObj.items || [];
      insertByIndex(dropObj.items, dragObj, isForm ? dropObj.items.length + 1 : destIndex);
      if (dropObj.items.length) {
        updatedObj = qbHelpersService.convertToShell(dropObj, 'items').dropObj;
      }
    }
  }
  updatedObj = { ...updatedObj, uuid: uuid() };
  nodeListArray = nodeListArray.map((obj, index) => {
    if (index === destIndex) {
      return updatedObj;
    }
    return obj;
  });

  nodeListArray = nodeListArray.filter((obj, index) => index !== dragIndex);

  dispatch({
    type: queryletConstants.MERGE_DRAG_NODES,
    payload: { updatedObj: nodeListArray },
  });
};

export const updateValueofQuery = (nodeChild, node, value, type) => (dispatch) => {
  /** Update the operation or value whichever is updated */
  nodeChild[type] = value;
  dispatch({
    type: queryletConstants.UPDATE_CHILDREN_VALUE,
    payload: {
      nodeId: node.uuid,
      parentId: node.id,
      childId: nodeChild.uuid ? nodeChild.uuid : nodeChild.id,
      child: nodeChild,
      isuuid: !!nodeChild.uuid,
    },
  });
};

export const updateImportedQuery = (nodeArr) => (dispatch) => {
  nodeArr.forEach((node) => {
    updateDataType(node);
  });
  dispatch({
    type: queryletConstants.UPDATE_NODES,
    payload: { nodesList: nodeArr },
  });
};

const updateGroupTitle = (nodeArr, titleNodeID, title) => {
  nodeArr.forEach((node) => {
    if (node.uuid === titleNodeID) {
      node.groupName = title;
      return;
    }
    if (node.items && node.items.length > 0) {
      updateGroupTitle(node.items, node.uuid, title);
    }
  });

  return { nodeArr };
};

export const updateGroupTitleAction = (node, updatedTitle, nodelist) => (dispatch) => {
  const { nodeArr } = updateGroupTitle(nodelist, node.uuid, updatedTitle);
  AppStorage.instance.set('qbNodesList', nodeArr);
  dispatch({
    type: queryletConstants.UPDATE_NODES,
    payload: { id: node.id, nodesList: nodeArr },
  });
};

const findArraytoUngroup = (items, targetId) =>
  items.reduce((acc, item) => {
    let newItem = { ...item };

    if (newItem.uuid === targetId) {
      const subItems = newItem.items && newItem.items.map(({ ...rest }) => ({ ...rest }));
      newItem = [...subItems];
      return [...acc, ...newItem]; // Return the modified item
    }

    // If the item has children, recurse into them
    if (newItem.items && newItem.items.length > 0) {
      newItem.items = findArraytoUngroup(newItem.items, targetId); // Recurse
    }

    acc.push(newItem);
    return acc;
  }, []);

export const ungroupAction = (nodesListArr, nodesUUid) => (dispatch) => {
  const updatedObj = findArraytoUngroup(nodesListArr, nodesUUid);
  dispatch({
    type: queryletConstants.MERGE_DRAG_NODES,
    payload: { updatedObj },
  });

  return updatedObj;
};

function unsetNodeValueIfExists(nodeValue) {
  if (nodeValue.value) {
    nodeValue.value = null;
  }
  if (nodeValue.structureData || nodeValue.structurePreview) {
    nodeValue.structurePreview = null;
    nodeValue.structureData = null;
    nodeValue.options = null;
    StructureContainers.removeContainerByUID(nodeValue.structureUID);
  }
  if (nodeValue.exist === true) {
    // a click on Reset will reset the "Find any" checkbox to the querylet default
    nodeValue.exist = false;
  }
  nodeValue.uuid = uuid();
}

export const resetNodeValueAction = (nodesArr) => (dispatch) => {
  eachHierarchy(
    nodesArr,
    (node) => {
      unsetNodeValueIfExists(node);
      each(node.children, unsetNodeValueIfExists);
    },
    null,
    { children: 'items', checkCircular: false }
  );
  AppStorage.instance.set('qbNodesList', nodesArr);
  dispatch({
    type: queryletConstants.UPDATE_NODES,
    payload: { nodesList: nodesArr },
  });
};

function _extractStructuresUIDs(nodesArray) {
  const uids = [];

  eachHierarchy(
    nodesArray,
    (node) => {
      if (node.structureUID) {
        uids.push(node.structureUID);
      }
    },
    null,
    { children: 'items' }
  );

  return uids;
}

function showAllQuerylets(propertiesArr, _hiddenList) {
  eachHierarchy(
    propertiesArr,
    (item) => {
      if (item.hidden) {
        setHidden(_hiddenList, item, false);
      }
    },
    null,
    { checkCircular: false }
  );
}

// eslint-disable-next-line no-shadow
export const resetSearchBuilderAction = (nodesList, properties, hiddenList) => {
  const _hiddenList = hiddenList;
  return (dispatch) => {
    const structureUIDs = _extractStructuresUIDs(nodesList);
    StructureContainers.removeContainersByUIDs(structureUIDs);
    AppStorage.instance.set('qbNodesList', []);
    showAllQuerylets(properties, _hiddenList);
    dispatch({
      type: queryletConstants.CLEAR_NODES_LIST_UPDATE_HIDDEN_LIST,
      payload: { hiddenList },
    });
  };
};

function clearQueryLet(data) {
  each(data.children, (child) => {
    unsetNodeValueIfExists(child);
  });
}

export const onToggleQueryletAction = (data) => (dispatch) => {
  if (data && data.canExist) {
    const updatedData = { ...data, exist: false };

    if (data.openQuerylet) {
      updatedData.openQuerylet = !AdvancedQuery.isQueryLetEmpty(data.children);

      if (updatedData.openQuerylet) {
        History.openConfirmPopup({
          title: 'Close querylet?',
          text: 'Closing the querylet will remove all entered values. Do you want to continue?',
          submitButtonText: 'Yes',
        })
          .then(() => {
            updatedData.openQuerylet = false;
            clearQueryLet(updatedData);
            dispatch({
              type: queryletConstants.UPDATE_INDIVIDUAL_NODE,
              payload: { uuid: data.uuid, data: updatedData },
            });
          })
          .catch(Logger.error);
      }
    } else {
      updatedData.openQuerylet = true;
    }

    dispatch({
      type: queryletConstants.UPDATE_INDIVIDUAL_NODE,
      payload: { uuid: data.uuid, data: updatedData },
    });
  } else {
    dispatch({
      type: queryletConstants.UPDATE_INDIVIDUAL_NODE,
      payload: { uuid: data.uuid, data },
    });
  }
};

export const onToggleFindAnyAction = (data) => (dispatch) => {
  const updatedData = { ...data, exist: !data.exist };
  dispatch({
    type: queryletConstants.UPDATE_INDIVIDUAL_NODE,
    payload: { uuid: data.uuid, data: updatedData },
  });
};

export const updateStructureandAdvancedAction = (data) => (dispatch) => {
  dispatch({
    type: queryletConstants.UPDATE_INDIVIDUAL_NODE,
    payload: { uuid: data.uuid, data },
  });
};

const findObjtoDelete = (nodesListArr, deletionUUID) =>
  nodesListArr.reduce((acc, item) => {
    // Create a shallow copy of the current item
    const newItem = { ...item };

    // If the current item's id matches the target id, skip it
    if (newItem.uuid === deletionUUID) {
      return acc; // Skip this item
    }

    // If the item has children, recurse into them
    if (newItem.items && newItem.items.length > 0) {
      newItem.items = findObjtoDelete(newItem.items, deletionUUID); // Recurse
    }

    // Push the updated item to the accumulator
    acc.push(newItem);
    return acc;
  }, []);

const containsNodeUuid = (nodesListArr, targetUuid) =>
  Array.isArray(nodesListArr) && nodesListArr.some((node) => node?.uuid === targetUuid || containsNodeUuid(node?.items, targetUuid));

function replaceGroupedItemsRecursively(array, collapsibleGroupUuid) {
  return array.reduce((acc, node) => {
    let updatedNode = node;

    if (node.items && Array.isArray(node.items)) {
      const updatedItems = replaceGroupedItemsRecursively(node.items, collapsibleGroupUuid);

      // Empty wrappers are removed at every nesting level, but non-wrapper nodes retain
      // their existing shape and empty children/items behavior.
      if (node.id === 'wrapper' && updatedItems.length === 0) {
        return acc;
      }

      updatedNode = { ...node, items: updatedItems };
    }

    // Only collapse the group that directly contained the deleted querylet. This
    // prevents a singleton child group from causing its parent group to collapse too.
    let isDirectParent = true;
    if (collapsibleGroupUuid === null) {
      isDirectParent = false;
    } else if (collapsibleGroupUuid) {
      isDirectParent = node.uuid === collapsibleGroupUuid;
    }
    if (updatedNode.id === 'wrapper' && isDirectParent && updatedNode.items?.length === 1 && !updatedNode.trackingSearchType) {
      const nonReplacementProps = pick(updatedNode, ['operator', 'operatorQualifier', 'trackingSearchType']);
      acc.push({ ...updatedNode.items[0], ...nonReplacementProps });
      return acc;
    }

    acc.push(updatedNode);
    return acc;
  }, []);
}
export const onPropUnSelectAction = (targetId, parent) => (dispatch) => {
  const directParent = findParentNode(parent, targetId);
  const targetExists = containsNodeUuid(parent, targetId);
  let updatedArray = findObjtoDelete(parent, targetId);

  // A valid top-level deletion has no group parent and must not normalize unrelated
  // nested groups. Keep the legacy fallback only when the target was not found at all.
  updatedArray = replaceGroupedItemsRecursively(updatedArray, targetExists ? (directParent?.uuid ?? null) : undefined);

  AppStorage.instance.set('qbNodesList', updatedArray);
  dispatch({
    type: queryletConstants.UPDATE_NODES,
    payload: { nodesList: updatedArray },
  });

  return updatedArray;
};

// eslint-disable-next-line default-param-last
function _searchFormById(formGroups = [], formId) {
  let foundForm;
  // eslint-disable-next-line radix
  formId = parseInt(formId);

  formGroups.every((group) => {
    const tmp = find(getValueByNs(group, 'children', []), (child) => getValueByNs(child, 'formId') === formId);
    if (tmp) {
      foundForm = tmp;
      return false;
    }
    return true;
  });

  return foundForm;
}

export function getFormsAction(formId) {
  return async (dispatch) => {
    try {
      const formsValue = await Search.getForms();
      const _forms = compact(formsValue).map((form) => ({
        ...form,
        id: form.id || form.displayName,
        uuid: uuid(),
        children: form.children.map((item) => ({ ...item, editMode: form.displayName === 'My Forms' })),
      }));

      // Index display names for forms search
      if (formId) {
        const nodeValue = _searchFormById(_forms, formId);
        dispatch(addToBuilderAction(nodeValue, 'qsforms'));
      }
      dispatch({
        type: queryletConstants.FETCH_FORMS,
        payload: { forms: _forms },
      });
    } catch (error) {
      Logger.error(error);
    }
  };
}

export function saveUserFormAction(updatedDisplayName, form) {
  return (dispatch, getState) => {
    const userForm = forms(getState());

    UserForms.editForm(form.formId, updatedDisplayName, form.content)
      .then(() => {
        const userFormId = userForm.findIndex((formValue) => formValue.displayName === 'My Forms');
        userForm[userFormId].children = userForm[userFormId].children.map((item) =>
          item.formId === form.formId ? { ...item, displayName: updatedDisplayName } : item
        );
        dispatch({
          type: queryletConstants.UPDATE_FORMS,
          payload: { forms: userForm },
        });
      })
      .catch(Logger.error);
  };
}

export function deleteUserFormAction(deletedForm) {
  return (dispatch, getState) => {
    const userForm = forms(getState());
    UserForms.deleteForm(deletedForm.formId)
      .then(() => {
        const userFormId = userForm.findIndex((form) => form.displayName === 'My Forms');

        userForm[userFormId].children = filter(userForm[userFormId].children, (form) => form.formId !== deletedForm.formId);
        userForm[userFormId].childrenCount = userForm[userFormId].children.length;
        dispatch({
          type: queryletConstants.UPDATE_FORMS,
          payload: { forms: userForm },
        });
      })
      .catch(Logger.error);
  };
}

function setDefaultHistoryTabsItems() {
  const tabsItemsStates = AppStorage.instance.get('qbSearchSectionStates') || {};

  const isOpened = some(keys(tabsItemsStates), (itemName) => itemName.indexOf('history-') !== -1);

  if (!isOpened) {
    extend(tabsItemsStates, {
      'history-Reaxys': true,
      'history-Reaxys-recent': true,
    });

    AppStorage.instance.set('qbSearchSectionStates', tabsItemsStates);
  }
}

export function getHistoryItemsAction() {
  return async (dispatch) => {
    try {
      const historyItems = await AdvancedHistory.getStructuredHistory();
      setDefaultHistoryTabsItems();
      dispatch({
        type: queryletConstants.FETCH_HISTORY_ITEMS,
        payload: { historyItems },
      });
    } catch (error) {
      Logger.error(error);
    }
  };
}

export function setSearchSectionOpenedTab(openedTab) {
  return {
    type: queryletConstants.SET_SEARCH_SECTION_PANEL_STATE,
    payload: { openedTab },
  };
}

export function setSearchSectionOpenedPanel(panelId, isOpen) {
  return (dispatch, getState) => {
    const excluding = searchSectionOpenedPanelsSelector(getState()).filter((_id) => _id !== panelId);
    const openedPanels = isOpen ? excluding.concat([panelId]) : excluding;
    dispatch({
      type: queryletConstants.SET_SEARCH_SECTION_PANEL_STATE,
      payload: { openedPanels },
    });
  };
}

export function setSearchSectionSearchValue(searchValue) {
  return {
    type: queryletConstants.SET_SEARCH_SECTION_PANEL_STATE,
    payload: { searchValue },
  };
}

export function cleanupOnUnmountAction() {
  return {
    type: queryletConstants.CLEANUP_ON_UNMOUNT,
  };
}
